
import { useAppDispatch } from "../../../redux/hooks"
import { setAdjustFilterPopup, setShowFilterAdjustPopup } from "../../../redux/reducers/popupSlice";
import "./AdjustFilter.scss";

export default function AdjustFilter(props: {
  field: { fieldCode: any; fieldValue: any };
}) {
  const dispatch = useAppDispatch();
  const cancelHanlde = () => {
    dispatch(setShowFilterAdjustPopup(false));
  }

  const confrimChangeHandle = () =>{
    dispatch(setAdjustFilterPopup(true))
    dispatch(setShowFilterAdjustPopup(false));
  }
  return (
    <section className="dtw-container">
      <div className="dtw-warning-text">
        Due to value change the document will be removed from filters
      </div>
      <div className="dtw-footer">
        <button
          className="dtw-button"
          onClick={cancelHanlde}
        >
          <span className="dtw-button-text">No</span>
        </button>
        <button
          className="dtw-button dtw-button-yellow"
          onClick={()=>confrimChangeHandle()}
        >
          <span className="dtw-button-text">Yes</span>
        </button>
      </div>
    </section>
  );
}
